"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWindowSize = void 0;
const react_1 = require("react");
const DEFAULT_WINDOW_WIDTH = 1200;
const DEFAULT_WINDOW_HEIGHT = 1200;
/**
 * Returns the current window size
 *
 * @returns { width: number, height: number }
 */
function useWindowSize() {
    const isSSR = typeof window === "undefined";
    const [windowSize, setWindowSize] = (0, react_1.useState)({
        width: isSSR ? DEFAULT_WINDOW_WIDTH : window.innerWidth,
        height: isSSR ? DEFAULT_WINDOW_HEIGHT : window.innerHeight,
    });
    function changeWindowSize() {
        setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    }
    (0, react_1.useEffect)(() => {
        if (isSSR) {
            return;
        }
        changeWindowSize();
        window.addEventListener("resize", changeWindowSize);
        return () => {
            window.removeEventListener("resize", changeWindowSize);
        };
    }, []);
    return windowSize;
}
exports.useWindowSize = useWindowSize;
//# sourceMappingURL=useWindowSize.js.map